import React, { useState } from "react";
import { Button } from "primereact/button";
import { ConfirmDialog } from "primereact/confirmdialog";
import { COPY } from "../ThgAnnualSummary.consts";
import "./RecomputeButton.css";

interface RecomputeButtonProps {
  year: number;
  recomputing: boolean;
  onRecompute: () => void;
  /** A credit-note action is running (CLR-283): recomputing now would change the figures under it. */
  disabled?: boolean;
}

/**
 * Replaces a final year's stored figures, which may already have been paid from, so it always asks
 * first, and cannot be triggered twice while the several-second recompute runs.
 *
 * The dialog is controlled rather than opened through the global `confirmDialog()` bus: the bus only
 * reaches a dialog that has already subscribed, and this one mounts together with the figures.
 */
const RecomputeButton: React.FC<RecomputeButtonProps> = ({ year, recomputing, onRecompute, disabled = false }) => {
  const [isConfirming, setIsConfirming] = useState(false);
  return (
    <>
      <ConfirmDialog
        visible={isConfirming}
        onHide={() => setIsConfirming(false)}
        header={`Recompute ${year}`}
        icon="pi pi-exclamation-triangle"
        message={COPY.recomputeConfirm(year)}
        acceptLabel="Recompute"
        rejectLabel="Cancel"
        // Red, not the theme's green: accepting overwrites figures that may already have been paid.
        acceptClassName="p-button-danger"
        className="thg-recompute-dialog"
        // Closed straight away on either choice rather than when the close animation reports back.
        accept={() => {
          setIsConfirming(false);
          onRecompute();
        }}
        reject={() => setIsConfirming(false)}
        style={{ width: "32rem" }}
      />
      <Button
        label="Recompute"
        icon="pi pi-refresh"
        severity="danger"
        outlined
        size="small"
        loading={recomputing}
        disabled={recomputing || disabled}
        onClick={() => setIsConfirming(true)}
      />
    </>
  );
};

export default RecomputeButton;
